<template>
  <mdb-navbar class="navbar" position="top" light>
    <mdb-navbar-brand
      tag="a"
      href="https://www.isi-insights.com/"
      target="_blank"
      waves
    >
      <img
        src="../assets/images/logos/isi-logo_2024.svg"
        alt="isi gmbh logo"
        class="navbar__logo"
      />
    </mdb-navbar-brand>
    <mdb-navbar-toggler>
      <mdb-navbar-nav right style="display: flex; align-items: center">
        <mdb-nav-item to="/" active-class="active" exact>Home</mdb-nav-item>
        <mdb-nav-item to="/search" active-class="active" exact
          >Find Test Studios</mdb-nav-item
        >
        <mdb-nav-item to="/about" active-class="active" exact
          >About</mdb-nav-item
        >
        <mdb-nav-item
          @click="$store.commit('setCurrentModal', { type: 'registerModal' })"
          v-if="!user"
          id="menuUserBtn"
        >
          <!--  <mdb-icon id="userlock-icon" icon="user-lock" /> -->
          <mdb-btn class="btn" color="isi" style="font-family: Arial"
            >Login / Register</mdb-btn
          >
        </mdb-nav-item>
        <template v-else>
          <mdb-nav-item
            to="/myRequestList"
            active-class="active"
            exact
            :style="myRequestStyles"
          >
            <mdb-icon
              id="shoppingcart-icon"
              icon="shopping-cart"
              class="mr-1"
            />Request List
            <span
              v-show="
                user.requestList.testStudioIds.length > 0 ||
                user.requestList.customLocations.length > 0
              "
              >&nbsp;({{
                user.requestList.testStudioIds.length +
                user.requestList.customLocations.length
              }})</span
            >
          </mdb-nav-item>
          <mdb-dropdown tag="li" class="nav-item float-right position-relative">
            <mdb-dropdown-toggle tag="a" navLink slot="toggle" waves-fixed>
              &nbsp;{{ user.displayName }}
              <mdb-icon icon="user" class="ml-1" size="sm" />
            </mdb-dropdown-toggle>
            <mdb-dropdown-menu>
              <!-- <mdb-dropdown-item to="/about">
                <mdb-icon icon="user" class="mr-1" />Profile
              </mdb-dropdown-item>-->
              <mdb-dropdown-item @click="handleChangePasswordClick">
                <mdb-icon icon="key" class="mr-1" />Change Password
              </mdb-dropdown-item>
              <mdb-dropdown-item @click="handleLogoutClick">
                <mdb-icon icon="sign-out-alt" class="mr-1" />Logout
              </mdb-dropdown-item>
            </mdb-dropdown-menu>
          </mdb-dropdown>
        </template>
      </mdb-navbar-nav>
    </mdb-navbar-toggler>
  </mdb-navbar>
</template>

<script>
export default {
  methods: {
    handleChangePasswordClick() {
      this.$store.commit("setCurrentModal", {
        type: "changePasswordModal",
      });
    },
    handleLogoutClick() {
      let role = this.$store.getters.user?.role;
      this.$store
        .dispatch("logoutUser", this.$http)
        .then(() => {
          if (this.$route.meta.protected) this.$router.go("Search");
          if (role == 2) location.reload();
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    myRequestStyles() {
      return {
        "font-weight":
          this.user.requestList.testStudioIds.length > 0 ||
          this.user.requestList.customLocations.length > 0
            ? "500"
            : "300",
      };
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/components/_nav.scss";
</style>


